import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { subscribePropertyToCapability, unsubscribePropertyFromCapability } from '~/services/AccommodationService';

import { capabilitiesQueryKeys } from './useGetCapability';

interface ToggleCapabilityParams {
  flag: string;
  propertyId: string;
  subscribe: boolean;
}

export default function useToggleCapability() {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: async ({ flag, propertyId, subscribe }: ToggleCapabilityParams) => {
      if (subscribe) {
        return subscribePropertyToCapability({ flag, propertyId });
      }
      return unsubscribePropertyFromCapability({ flag, propertyId });
    },
    onSuccess: (_data, { flag }) => {
      queryClient.invalidateQueries({ queryKey: capabilitiesQueryKeys.detail(flag) });
    },
    onError: (error: Error, { subscribe }) => {
      enqueueSnackbar(
        `Failed to ${subscribe ? 'add' : 'remove'} property ${subscribe ? 'to' : 'from'} capability: ${error.message}`,
        { variant: 'error' },
      );
    },
  });
}
